import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TechCheckService } from 'src/app/_services/_techCheck/tech-check.service';
import { ExtendedTechCheckComponent, EXTENDED_TECH_CHECK_TYPE } from '../extended-tech-check/extended-tech-check.component';
import { TechCheckUserValidationComponent } from '../tech-check-user-validation/tech-check-user-validation.component';

@Component({
  selector: 'app-check-requirements',
  templateUrl: './check-requirements.component.html',
  styleUrls: ['./check-requirements.component.scss'],
})
export class CheckRequirementsComponent implements OnInit {
  streamingBrowsers = ['Google Chrome', 'Firefox', 'Opera', 'Safari'];

  networkingBrowsers = ['Google Chrome', 'Firefox', 'Opera', 'Safari', 'MicrosoftInternetExplorer'];

  workshopBrowsers = ['Google Chrome', 'Firefox', 'Edge'];

  browser;
  EXTENDED_TECH_CHECK_TYPE;
  browserversion;
  internetConnection = { download: '0' };

  canUseStreaming = 0;
  canUseWorkshop = 0;
  canUseNetworking = 0;
  canUSeInternet = 0;
  canUseBrowser = 0;

  displayDetails = false;
  hasProblems = false;

  isLoading = true;
  errormessage = '';
  isDialog = true;
  mobile = false;

  workshopTroublMes =
    '<b>Workshop</b>: Bitte führen Sie zur Fehleranalyse den erweiterten Test durch. Zu diesem gelangen Sie durch Klicken auf den "Erweiterten Test" Button. Bitte wählen Sie dann "Check starten" und warten Sie bis dieser vollständig abgeschlossen ist. Dann können Sie den "Report" Button auswählen. Diesen würden wir Sie bitten an <a href="mailto:support@streavent.de">support@streavent.de</a> zu schicken. <br> Please run the extended check below by selecting "Extended Check Workshop Rooms". Please select "Check starten" and wait for the test to finish. Then select "Report" to save the analysis and send it to <a href="mailto:support@streavent.de">support@streavent.de</a>. <br> <br> Sollten Sie Probleme haben den Test auszüführen, können sie diesen auch <a href="https://check.streavent.de" target="_blank">hier</a> durchführen. Dies öffnet einen neuen Tab. <br> If you have problems running it you can also try <a href="https://check.streavent.de" target="_blank">this</a> link. It will open a new tab.<br>';
  streamTroubleMes =
    '<b>Streaming</b>: Bitte kontaktieren Sie den Veranstalter oder versuchen Sie es erneut. //  Please contact the organizor of the event or retry. <br>';

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    if (screen.width <= 699) {
      this.mobile = true;
    }
    if (this.dialog.openDialogs.length === 0) {
      this.isDialog = false;
    }
    this.checkStreamingRequirements();
    this.checkBrowserVersion();
  }

  checkBrowserVersion() {
    if (this.canUseStreaming && this.canUseWorkshop && this.canUseNetworking) {
      this.canUseBrowser = 1;
    } else {
      this.canUseBrowser = 2;
      this.hasProblems = true;
      this.errormessage =
        this.errormessage +
        'Aktuell unterstützen wir nur Firefox, Chrome, Opera und Edge. Der Internet Explorer und Safari werden leider nicht unterstützt. Bitte nutzen Sie einen anderen Browser. // Only Firefox, Chrome, Opera, and Edge are support at the moment. We do not support Microsoft Internet Explorer or Safari. Please use a different browser.';
    }
    this.browserversion = this.getBrowserName();
    this.isLoading = false;
    this.displayDetails = true;
  }

  checkStreamingRequirements() {
    if (this.streamingBrowsers.includes(this.getBrowserName())) {
      this.canUseStreaming = 1;
    } else {
      this.canUseStreaming = 2;
    }
    this.checkWorkshopRequirements();
  }

  checkNetworkingRequirements() {
    if (this.networkingBrowsers.includes(this.getBrowserName())) {
      this.canUseNetworking = 1;
    } else {
      this.canUseNetworking = 2;
    }
  }

  checkWorkshopRequirements() {
    if (this.workshopBrowsers.includes(this.getBrowserName())) {
      this.canUseWorkshop = 1;
    } else {
      this.canUseWorkshop = 2;
    }
    this.checkNetworkingRequirements();
  }

  getBrowserName() {
    const navUserAgent = navigator.userAgent;
    let browserName = navigator.appName;

    if (navUserAgent.indexOf('Opera') !== -1) {
      browserName = 'Opera';
    } else if (navUserAgent.indexOf('MSIE') !== -1) {
      browserName = 'MicrosoftInternetExplorer';
    } else if (navUserAgent.indexOf('Chrome') !== -1) {
      browserName = 'Google Chrome';
    } else if (navUserAgent.indexOf('Safari') !== -1) {
      browserName = 'Safari';
    } else if (navUserAgent.indexOf('Firefox') !== -1) {
      browserName = 'Firefox';
    }

    // this.browserversion = browserName + navUserAgent;

    return browserName;
  }

  extendedCheck(type: EXTENDED_TECH_CHECK_TYPE) {
    this.dialog
      .open(ExtendedTechCheckComponent, { data: { checkType: type }, width: '80%', height: '95%' })
      .afterClosed()
      .subscribe(() => {
        if (type === EXTENDED_TECH_CHECK_TYPE.JOIN_BBB) {
          this.dialog
            .open(TechCheckUserValidationComponent, {
              data: { question: 'Haben Sie sich im Workshop Raum selbst gehört? // Did you hear yourself in the Workshop Room?' },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                this.canUseWorkshop = 1;
                if (this.errormessage.includes('Streaming')) {
                  this.errormessage = this.errormessage.replace(this.workshopTroublMes, '');
                } else {
                  this.hasProblems = false;
                  this.errormessage = '';
                }
              } else {
                this.canUseWorkshop = 2;
                this.hasProblems = true;
                if (!this.errormessage.includes('Workshop')) {
                  this.errormessage += this.workshopTroublMes;
                }
              }
            });
        } else {
          this.dialog
            .open(TechCheckUserValidationComponent, {
              data: { question: 'Konnten Sie den Stream verfolgen? // Could you watch the stream?' },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                this.canUseStreaming = 1;
                if (this.errormessage.includes('Workshop')) {
                  this.errormessage = this.errormessage.replace(this.streamTroubleMes, '');
                } else {
                  this.hasProblems = false;
                  this.errormessage = '';
                }
              } else {
                this.canUseStreaming = 2;
                this.hasProblems = true;
                if (!this.errormessage.includes('Streaming')) {
                  this.errormessage += this.streamTroubleMes;
                }
              }
            });
        }
      });
  }

  bbbTrouble() {
    const dialog = this.dialog.open(ExtendedTechCheckComponent, {
      data: { checkType: EXTENDED_TECH_CHECK_TYPE.TROUBLE_BBB },
      width: '80%',
      height: '95%',
    });
  }
}
